import React from 'react';
import { Bubble, Dot } from './styles';

export const TypingBubble = (): JSX.Element => {
  return (
    <Bubble>
      <Dot style={{ animationDelay: '0s' }} />
      <Dot style={{ animationDelay: '0.3s' }} />
      <Dot style={{ animationDelay: '0.6s' }} />
    </Bubble>
  );
};
